// Telcos Data - Telecommunications Operators

export const telcosHeroData = {
  tagline: "OPERADORES TELCO",
  title: "Transforma tu negocio telco con servicios cloud de valor agregado",
  subtitle: "Plataforma integral para operadores de telecomunicaciones que buscan diversificar ingresos, reducir churn y ofrecer servicios digitales diferenciados a sus clientes.",
  cta: "Comenzar ahora",
  secondaryCta: "Ver demo"
};

export const telcosStatsData = [
  { number: "45%", label: "Nuevos ingresos digitales" },
  { number: "-30%", label: "Reducción de churn" },
  { number: "2M+", label: "Facturas procesadas/mes" },
  { number: "120+", label: "Servicios en catálogo" }
];

export const convergentBillingData = [
  {
    id: 1,
    title: "Facturación Convergente",
    description: "Unifica servicios de conectividad, cloud y digitales en una única factura para el cliente final.",
    icon: "Receipt"
  },
  {
    id: 2,
    title: "Mediation & Rating",
    description: "Procesa CDRs, aplica tarifas y calcula consumos en tiempo real con precisión del 99.99%.",
    icon: "Calculator"
  },
  {
    id: 3,
    title: "Revenue Assurance",
    description: "Detecta fugas de ingresos, reconcilia automáticamente y protege márgenes operativos.",
    icon: "ShieldCheck"
  },
  {
    id: 4,
    title: "Dunning Automatizado",
    description: "Gestiona cobros, recordatorios y suspensiones de servicio de forma automatizada.",
    icon: "Bell"
  }
];

export const digitalServicesData = [
  {
    id: 1,
    title: "Cloud Marketplace",
    description: "Ofrece Microsoft 365, Google Workspace, AWS y más como servicios de valor agregado.",
    icon: "Cloud",
    examples: ["Microsoft 365", "Google Workspace", "AWS"]
  },
  {
    id: 2,
    title: "Seguridad Gestionada",
    description: "Servicios de ciberseguridad, backup y disaster recovery para pymes y enterprise.",
    icon: "Shield",
    examples: ["Firewall as a Service", "Backup Cloud", "SOC"]
  },
  {
    id: 3,
    title: "IoT & Conectividad",
    description: "Gestiona flotas de SIMs, dispositivos IoT y servicios M2M desde una única plataforma.",
    icon: "Wifi",
    examples: ["Fleet Management", "Smart Metering", "Asset Tracking"]
  },
  {
    id: 4,
    title: "Comunicaciones Unificadas",
    description: "UCaaS, centralitas virtuales y colaboración empresarial integrados con tu red.",
    icon: "PhoneCall",
    examples: ["UCaaS", "Contact Center", "Video Conferencing"]
  }
];

export const bssOssFeaturesData = [
  {
    id: 1,
    title: "Catálogo de Productos",
    description: "Gestiona ofertas comerciales complejas con bundles, promociones y pricing dinámico.",
    icon: "ShoppingBag"
  },
  {
    id: 2,
    title: "Order Management",
    description: "Orquestación de pedidos end-to-end con provisioning automático multi-vendor.",
    icon: "ClipboardList"
  },
  {
    id: 3,
    title: "Customer 360",
    description: "Vista unificada del cliente con historial, servicios activos y oportunidades de upsell.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Partner Management",
    description: "Portal para distribuidores y agentes con comisiones, cuotas y reportes automatizados.",
    icon: "Handshake"
  }
];

export const networkIntegrationData = [
  {
    id: 1,
    title: "APIs de Red",
    description: "Integración con OSS/BSS existentes mediante APIs REST y protocolos estándar telco.",
    icon: "Network"
  },
  {
    id: 2,
    title: "Provisioning Automático",
    description: "Activa servicios en la red (voz, datos, cloud) de forma automática tras la venta.",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Service Assurance",
    description: "Monitoreo de SLAs, detección de fallas y gestión proactiva de incidencias.",
    icon: "Activity"
  },
  {
    id: 4,
    title: "Inventory Management",
    description: "Control de recursos de red, SIMs, equipos CPE y activos digitales.",
    icon: "Database"
  }
];

export const telcoUseCasesData = [
  {
    id: 1,
    title: "FTTH + Cloud Bundle",
    description: "Ofrece fibra óptica con Microsoft 365 incluido para diferenciarte de la competencia.",
    benefit: "+25% ARPU"
  },
  {
    id: 2,
    title: "Móvil Empresarial",
    description: "Planes corporativos con MDM, seguridad y apps de productividad integradas.",
    benefit: "-40% churn"
  },
  {
    id: 3,
    title: "IoT Vertical",
    description: "Soluciones verticalizadas para smart cities, agricultura o logística con conectividad.",
    benefit: "Nuevo revenue stream"
  },
  {
    id: 4,
    title: "SD-WAN Gestionado",
    description: "Conectividad empresarial con SD-WAN, seguridad y SLA garantizado.",
    benefit: "+60% margen"
  }
];

export const telcosFAQData = [
  {
    question: "¿Cómo se integra con nuestro BSS/OSS actual?",
    answer: "La plataforma está diseñada para coexistir e integrarse con sistemas legacy. Ofrecemos APIs REST, conectores para los principales BSS del mercado (Amdocs, Ericsson, Comverse) y servicios de integración personalizados. Podemos funcionar como capa de servicios digitales sobre tu stack existente."
  },
  {
    question: "¿Qué servicios digitales puedo ofrecer a mis clientes?",
    answer: "Tenemos un catálogo de más de 120 servicios listos para revender: productividad (Microsoft 365, Google Workspace), seguridad (backup, antivirus, firewall), infraestructura cloud (AWS, Azure, GCP), comunicaciones (UCaaS, Contact Center) y más. También puedes añadir servicios propios."
  },
  {
    question: "¿Cómo funciona la facturación convergente?",
    answer: "Consolidamos todos los servicios del cliente (conectividad, voz, cloud, digitales) en una única factura. Soportamos modelos de pricing complejos: tarifas planas, consumo, bundles, promociones temporales y descuentos por fidelidad. La reconciliación con vendors es automática."
  },
  {
    question: "¿Pueden gestionar alto volumen de transacciones?",
    answer: "Sí, la plataforma procesa millones de transacciones mensuales. Está diseñada para escalar horizontalmente y soportar picos de demanda. Tenemos clientes telco procesando más de 2 millones de facturas mensuales sin degradación de rendimiento."
  },
  {
    question: "¿Qué soporte ofrecen para telcos?",
    answer: "Los operadores telco tienen acceso a un equipo dedicado de Customer Success, soporte técnico 24/7 con SLA garantizado, servicios profesionales de integración y consultoría estratégica para diseño de ofertas y go-to-market."
  }
];

export const telcoTestimonialData = {
  quote: "Implementar servicios cloud como parte de nuestra oferta nos ha permitido aumentar el ARPU un 35% y reducir el churn significativamente. La plataforma nos dio la agilidad que necesitábamos para competir con los OTTs.",
  author: "",
  role: "Director de Nuevos Negocios",
  company: "Telia",
  location: ""
};
